

















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import FilterDapp from '@/components/filters/FilterDapp.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import DappCard from '@/components/cards/DappCard.vue'
import {DappCollection} from '@/model/collection/DappCollection'
import NavHeaderMenu from '@/components/NavHeaderMenu.vue'
import DappsHeader from '@/components/DappsHeader.vue'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {Dapp} from '@/model/resource/Dapp'

@Component({
  components: {
    NavHeaderMenu,
    DappCard,
    FilterToggle,
    FilterDapp,
    Navbar,
    AppFooter,
    DappsHeader,
  },
})
export default class DappsOverview extends Vue {
  @Prop({type: String, default: null}) privateCategorySlug!: string | null
  @Prop({type: Boolean, required: true}) isDapp!: boolean
  @Prop({type: String, required: true}) toOverviewView!: string

  collection = new DappCollection()
  orbitProjectCollection = new OrbitProjectCollection()

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  async mounted() {
    this.applyCollection()
    await this.populateResources()
  }

  applyCollection() {
    this.collection.isDapp = this.isDapp
    this.collection.orderBy = 'publishedDate'
    this.collection.asc = false
    this.collection.requestName = 'overview'
    this.collection.perPage = 30
    this.collection.interval = 1
    this.collection.privateCategorySlug = this.privateCategorySlug
    this.collection.private = this.collection.isPrivate
  }

  async populateResources() {
    const reqs: Array<Promise<any>> = [this.collection.expand()]
    if (this.isOrbitEnabled) {
      reqs.push(this.orbitProjectCollection.queryAsPage())
    } else {
      // Ensure we don't show stale orbit markers when feature is disabled.
      this.orbitProjectCollection.items = []
    }
    await Promise.all(reqs)
  }

  isOrbitProject(item: Dapp) {
    return this.orbitProjectCollection.items.some(
      orbitProject =>
        orbitProject.contract &&
        orbitProject.contract.dapp &&
        orbitProject.contract.dapp.idDappPk === item.idDappPk
    )
  }

  @Watch('$route.name')
  async routeNameEvent() {
    await this.collection.queryToFirstPage()
  }
}
